import React from 'react';
import { ResourceCollaboration } from 'new/elements/ResourceCollaboration';
import { useDrawerContext } from 'new/components/drawer/useDrawerContext';

interface NexsetShareProps {
  resourceType: string;
  resourceId: string;
}

export const NexsetShare = (props: NexsetShareProps) => {
  const { drawerContentRef } = useDrawerContext();
  return <ResourceCollaboration usePillTabs parentScrollRef={drawerContentRef} {...props} />;
};
